import type { TextInputType, TextStandardInput } from "./form-types";
import type { StepInputRendererProps } from "./StepInputRenderer";

type TextInputConfig = {
  defaultLabel: string;
  type: "text" | "email" | "tel";
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>["inputMode"];
  autoComplete?: string;
};

const TEXT_INPUT_CONFIG: Record<TextInputType, TextInputConfig> = {
  email: {
    autoComplete: "email",
    defaultLabel: "Email Address",
    type: "email",
  },
  firstName: {
    autoComplete: "given-name",
    defaultLabel: "First Name",
    type: "text",
  },
  lastName: {
    autoComplete: "family-name",
    defaultLabel: "Last Name",
    type: "text",
  },
  phone: { autoComplete: "tel", defaultLabel: "Phone Number", type: "tel" },
  postalCode: {
    autoComplete: "postal-code",
    defaultLabel: "Postal Code",
    inputMode: "numeric",
    type: "text",
  },
};

function resolveLabel(input: TextStandardInput): string {
  const config = TEXT_INPUT_CONFIG[input.inputType];
  return input.labelOverride ?? config.defaultLabel;
}

function resolvePlaceholder(input: TextStandardInput): string {
  return input.placeholderOverride ?? resolveLabel(input);
}

function isTextInputType(inputType: string): inputType is TextInputType {
  return inputType in TEXT_INPUT_CONFIG;
}

type StandardInputErrors = StepInputRendererProps["errors"];

export type { StandardInputErrors, TextInputConfig };

export { isTextInputType, resolveLabel, resolvePlaceholder, TEXT_INPUT_CONFIG };
